module.exports = __webpack_public_path__ + "saravana-cdb642f39bccc73ab7c19af28203c46a.png";